import { useNavigate } from 'react-router';

/**
 * useNavigate() wrapper from remix-run/react that supports external routing.
 */
export function useRouterNavigate() {
  const navigate = useNavigate();
  return (to: string, isExternal?: (to: string) => boolean) => {
    const external = isExternal?.(to);
    if (external && typeof window !== 'undefined') {
      window.location.href = to;
    } else {
      navigate(to);
    }
  };
}
